define([
	"dojo/_base/declare",
	"csi/heading/Number",
	"csi/locale"
], function(declare,NumberRen,locale) {

	return declare(NumberRen, {

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: convert value to displayed value - Show 'Unlimited' if the value is zero
			return (Number(value) <= 0) ? locale.resource("Unlimited") : this.inherited(arguments);
		}
	});
});